import React, { useContext } from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import { privateRoutes, publicRoutes, RouteNames } from ".";
import { Context } from "../index";

function AppRoutes() {
  const { authStore } = useContext(Context);
  const user = authStore.user?.roles?.length === 1 && authStore.user.roles.includes("USER")
  const privatRoutesSlice = user ? privateRoutes?.filter(item => item.path !== '/panel') : privateRoutes

  return authStore.isAuth ? (
    <Switch>
      {privatRoutesSlice.map((route) => (
        <Route {...route} key={route.path}></Route>
      ))}
      <Redirect to={RouteNames.LOGIN}/>
    </Switch>
  ) : (
    <Switch>
      {publicRoutes.map((route) => (
        <Route {...route} key={route.path}></Route>
      ))}
        {/* <Redirect to={RouteNames.MAIN}/> */}
    </Switch>
  );
}

export default AppRoutes;
